import http from "services/httpService";

export const handleFileGeneration = async (documentId, selectedProvider, type) => {
  const payload = {
    document_id: documentId,
    service_provider_id: selectedProvider,
    type: type || "inception",
  };
  console.log({ payload });
  try {
    const { data } = await http.post("/business/client_data_layers/", payload, {
      responseType: "blob",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    if (error.response) {
      // The response was received but with a status code outside the range of 2xx
      const blob = error.response.data;
      const reader = new FileReader();

      reader.onload = function () {
        const errorText = reader.result;
        try {
          const errorJson = JSON.parse(errorText);
          console.error("Error Response Data:", errorJson);

          // Display user-friendly error message
          if (error.response.status === 400) {
            alert(
              `Bad Request: ${
                errorJson.message || "Please check the data you have entered."
              }`
            );
          } else {
            alert(
              `An error occurred: ${
                errorJson.message || error.response.statusText
              }`
            );
          }
        } catch (e) {
          console.error("Error parsing blob response:", e);
          alert(`An unexpected error occurred: ${errorText}`);
        }
      };

      reader.onerror = function () {
        console.error("Error reading blob response:", reader.error);
        alert("An unexpected error occurred while reading the error message.");
      };

      reader.readAsText(blob);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Error Request:", error.request);
      alert("No response from the server. Please try again later.");
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message);
      alert("An unexpected error occurred. Please try again.");
    }
  }
};
